<p class="title h4">Nuova richiesta</p>

<div class="row">
  <div class="col">
    <app-request-summary [request]="request"></app-request-summary>
  </div>
</div>
<div class="row mt-3">
  <div class="col">
    <it-steppers-container [activeStep]="activeStep" steppersNumber="true" showBackButton="false" class=""
      showForwardButton="false">
      <it-steppers-item label="Seleziona Paziente">
        <div class="container">

          <ng-container *ngIf="!request?.patient">
            <p>Cerca paziente:</p>
            <div class="row mt-3">
              <form #myForm="ngForm" class="d-flex align-items-baseline w-100 gap-2">
                <it-input class="flex-grow-1" label="Codice Fiscale" placeholder="Inserisci il codice fiscale"
                  [type]="'text'" [(ngModel)]="fiscalCode" name="myInput" minlength="16" maxlength="16"
                  pattern="^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9A-Za-z]{3}[A-Za-z]{1}$"></it-input>

                <button *ngIf="!noPatientFound" itButton="outline-primary" [disabled]="!myForm.valid"
                  (click)="findPatient()">
                  Ricerca paziente
                </button>
              </form>
            </div>
          </ng-container>
          <ng-container *ngIf="request?.patient">
            <div class="row mb-2">
              <div class="col">
                <it-callout [appearance]="'highlight'" [color]="'success'"
                  [label]="'Paziente identificato con successo'">
                  <p>
                    Il paziente è stato identificato. Premi <strong>“Avanti”</strong> per creare la pratica di
                    transizione.
                  </p>
                  <p *ngIf="!authService.isOperatoreMmg">
                    Se vuoi cercare un altro paziente, premi <strong>“Annulla”</strong>.
                  </p>
                </it-callout>
              </div>
            </div>

          </ng-container>
          <ng-container *ngIf="noPatientFound">
            <div class="row mb-2">
              <div class="col">
                <it-callout [appearance]="'highlight'" [color]="'danger'" [label]="'Paziente non identificato'">
                  <p>
                    Il paziente non è stato trovato in anagrafica. Premi <strong>“+ Nuovo Paziente”</strong> per
                    crearlo.
                  </p>
                  <p>
                    <button itButton="outline-primary" class="me-2" [disabled]="false" data-bs-toggle="modal"
                      data-bs-target="#newPatientModal">
                      + Nuovo Paziente
                    </button>
                  </p>
                </it-callout>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="row">
          <div class="col text-center">
            <button *ngIf="!authService.isOperatoreMmg" [disabled]="!request?.patient" itButton="outline-primary" class="me-2" (click)="refreshPatient()">
              Annulla
            </button>
            <button itButton="primary" class="me-2" [disabled]="!request?.patient" (click)="goOn()">
              Avanti
            </button>
          </div>
        </div>
      </it-steppers-item>

      <it-steppers-item label="Seleziona Setting">
        <div class="container">
          <div class="row">
            <div class="col">
              <p>Seleziona Setting:</p>
              <p class="example-section">
                <it-select id="default-select" [(ngModel)]="selectedSetting" defaultOption="Seleziona Setting"
                  (ngModelChange)="onSelectedSetting($event)">
                  <option [value]="null">Seleziona Setting</option>
                  <option *ngFor="let setting of settings" [value]="setting.code">
                    {{ setting.name }}
                  </option>
                </it-select>
              </p>
              <!-- <p class="example-section" *ngIf="selectedSetting && getSubsettings() && getSubsettings().length>1">
                <it-select
                  id="default-select"
                  label="Sub-setting"
                  [(ngModel)]="selectedSubsetting"
                  defaultOption="Seleziona un elemento"
                >
                  <option [value]="null">Seleziona un elemento</option>
                  <option
                    *ngFor="let subsetting of getSubsettings()"
                    [value]="subsetting.id"
                  >
                    {{ subsetting.name }}
                  </option>
                </it-select>
              </p> -->
            </div>
          </div>

          <div class="row">
            <div class="col text-center">
              <button itButton="outline-primary" class="me-2" (click)="goBack()">
                Indietro
              </button>
              <button itButton="primary" class="me-2" [disabled]="!selectedSubsetting" (click)="goOn()">
                Avanti
              </button>
            </div>
          </div>
        </div>
      </it-steppers-item>
    </it-steppers-container>
  </div>
</div>

<it-modal #rightModal="itModal" alignment="left" scrollable="true" id="newPatientModal" size="xl">
  <ng-container modalTitle>Nuovo Paziente</ng-container>
  <div class="row" *ngIf="errorMessageFiscalCode">
    <div class="col">
      <it-alert color="danger">
        Attenzione! Il codice fiscale inserito non è coerente con i dati anagrafici.
      </it-alert>
    </div>
  </div>
  <div class="row" *ngIf="errorMessage">
    <div class="col">
      <it-alert color="info">
        Il codice fiscale calcolato è diverso da quello precedentemente inserito.
      </it-alert>
    </div>
  </div>
  <form [formGroup]="formPatient">
    <div class="row mt-4">
      <div class="col-8">
        <it-input label="Codice Fiscale" [type]="'text'" formControlName="fiscalCode"></it-input>
      </div>
      <div class="col-4">
        <button itButton="primary" size="lg" type="button"
          [disabled]="!(formPatient.controls['name'].value && formPatient.controls['surname'].value && formPatient.controls['birthDate'].value && formPatient.controls['birthTown'].value && formPatient.controls['sex'].value) || errorMessageFiscalCode"
          (click)="calculateFiscalCode()">
          Calcola codice fiscale
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-6">
        <it-input label="Nome" [type]="'text'" formControlName="name"></it-input>
      </div>
      <div class="col-6">
        <it-input label="Cognome" [type]="'text'" formControlName="surname"></it-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <it-input label="Data di Nascita" [type]="'date'" formControlName="birthDate"
          (ngModelChange)="getBirthTown()"></it-input>
      </div>
      <div class="col-6">
        <!-- <it-input
        label="Luogo di Nascita"
        [type]="'text'"
        formControlName="birthTown"
      ></it-input> -->
        <it-autocomplete #birthAutocomplete label="Luogo di nascita" placeholder="Inizia a scrivere" [source]="source"
          (selected)="changeBirthTown($event)" [itDisabled]="errorMessageFiscalCode" [ngClass]="{ 'autocomplete-disabled': formPatient.disabled }" />
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <it-select id="default-select" label="Sesso" formControlName="sex" defaultOption="Seleziona un elemento">
          <option [value]="'M'">Maschio</option>
          <option [value]="'F'">Femmina</option>
        </it-select>
      </div>
      <div class="col-9">
        <it-input label="Indirizzo di Residenza" [type]="'text'" formControlName="residentialAddress"></it-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <!-- <it-input
        label="Città di residenza"
        [type]="'text'"
        formControlName="residentialTown"
      ></it-input> -->
        <it-autocomplete #residentialAutocomplete label="Città di residenza" placeholder="Inizia a scrivere" [source]="source"
          formControlName="residentialTown" [itDisabled]="errorMessageFiscalCode" [ngClass]="{ 'autocomplete-disabled': formPatient.disabled }"/>
      </div>
      <div class="col-6">
      <it-input label="Email" [type]="'text'" formControlName="emailAddress"></it-input>
    </div>
    </div>
  </form>
  <ng-container footer *ngIf="errorMessageFiscalCode">
    <button itButton="primary" size="lg" type="button" [disabled]="!formPatient.valid" (click)="savePatientDirect()">
      Procedi comunque
    </button>
    <button itButton="primary" size="lg" type="button" (click)="modifyPatient()">
      Modifica i dati
    </button>
    <button itButton="outline-primary" size="lg" type="button" data-bs-dismiss="modal">
      Chiudi
    </button>
  </ng-container>
  <ng-container footer *ngIf="!errorMessageFiscalCode">
    <button itButton="primary" size="lg" type="button" [disabled]="!formPatient.valid" (click)="savePatient()">
      Crea
    </button>
    <button itButton="outline-primary" size="lg" type="button" data-bs-dismiss="modal">
      Chiudi
    </button>
  </ng-container>
</it-modal>

<it-modal #activeRequestModal="itModal" scrollable="true" footerShadow="true" id="activeRequestModal" size="xl">
  <ng-container modalTitle>Attenzione!!!</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <it-alert color="warning">
    <ng-container heading>Pratiche attive per questo paziente</ng-container>

    <p>
      Di seguito sono elencate le pratiche attive relative al paziente selezionato.<br>
      Per visualizzare i dettagli di una pratica, clicca sull’icona a destra.<br>
      Per creare una nuova pratica, premi il pulsante “Continua e crea una nuova pratica”</p>
    <hr />
    <it-table>
      <ng-container thead>
        <tr>
          <th scope="col">Data apertura</th>
          <th scope="col">N pratica</th>
          <th scope="col">Operatore</th>
          <th scope="col">Setting</th>
          <th scope="col">Stato</th>
          <th scope="col">Dettaglio</th>
        </tr>
      </ng-container>

      <ng-container tbody>
        <tr *ngFor="let request of activeRequests">
          <td>{{ request.insertDateTime | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ request.code }}</td>
          <td>{{ request.insertUser.code }}</td>
          <td>{{ request.setting.name }}</td>
          <td>
            <span [itBadge]="getBadgeColor(request.status.code)" [rounded]="'true'"
              class="d-inline-block w-100 text-center">
              {{ request.status.name }}
            </span>
          </td>
          <td class="p-0 text-center">
            <a data-bs-dismiss="modal" [routerLink]="['/detail/' + request.uuid]"
              class="d-block px-2 py-2 text-decoration-none">
              <it-icon name="file" size="sm" color="primary"></it-icon>
            </a>
          </td>
        </tr>
      </ng-container>
    </it-table>
  </it-alert>

  <ng-container footer>
    <button itButton="primary" size="sm" type="button" data-bs-dismiss="modal">Continua e crea una nuova
      pratica</button>
  </ng-container>
</it-modal>